import React from 'react'

import { Value as Component } from './Value'

const Value = props => {
  return <Component {...props} />
}
export default Value
